import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '@app/services/storage/storage.service';
import { ApplicationService } from '@app/services/application/application.service';
import { StateService } from '@app/services/state/state.service';
declare let gtag: Function;

@Component({
  selector: 'nh-appeals-dashboard',
  templateUrl: './appeals-dashboard.component.html',
  styleUrls: ['./appeals-dashboard.component.scss'],
  standalone: false
})
export class AppealsDashboardComponent {
  applicationNum: any;

  constructor(private router: Router,
    private application: ApplicationService,
    private storageService: StorageService,
    private stateService: StateService
  ) { }

  goToEligibilityAppeals() {
    this.router.navigateByUrl('user-profile/my-appeals');
  }

  startMedicalAppeal(appType : string) {
    this.application.getHeadOfHouseholdInfo(0, 'MEDICAL_APPEAL', 'MEDICAL_APPEAL').subscribe((res: any) => {
       gtag('event', 'start_medical_appeal', {
        'event_category': 'start_medical_appeal',
        'event_label': 'start_medical_appeal',
      });
      this.applicationNum = res?.applicationNumber;
      if (this.applicationNum && this.storageService.getAppNumber() !== this.applicationNum) {
        sessionStorage.setItem('appNum', this.applicationNum);
        this.storageService.setAppNumber(this.applicationNum);
      }
      if (this.applicationNum && this.applicationNum !== '0' && this.applicationNum !== 0) {
        this.stateService.resetStates();
        this.application.deleteApp(this.applicationNum, 'TCMAP').subscribe(() => {
          sessionStorage.setItem('appNum', null);
          this.storageService.setApplicationType(appType);
          this.router.navigateByUrl('/application/' + 'NEW');
          if(sessionStorage.getItem('mademAddressValidated')) {
            sessionStorage.removeItem('mademAddressValidated');
          }
        })
      }
      else {
        this.stateService.resetStates();
        sessionStorage.setItem('appNum', null);
        this.storageService.setApplicationType(appType);
        this.router.navigateByUrl('/application/' + 'NEW');
        if(sessionStorage.getItem('mademAddressValidated')) {     
          sessionStorage.removeItem('mademAddressValidated');
        }
      }
    });
  }
}